import baseUrl from '../utils/baseUrl';
console.log(baseUrl)
export const increase = baseUrl + '/api/statistics.customer/increase';// 数据统计－客户分析
export const callList = baseUrl + '/api/customer.member/callList';// 云客电话记录
export const dashboard = baseUrl + '/api/dashboard.dashboard/index';// dashboard
export const wash = baseUrl + '/api/dashboard.dashboard/wash';// dashboard
export const recommend = baseUrl + '/api/dashboard.dashboard/recommend';// dashboard